import type { ISODateRange } from 'shared/src/date-string-utils/types';
import { today, subtractDays } from 'shared/src/date-string-utils/date-utils';

export type DateRangeState = 'pending' | 'active' | 'expired';

export function getDateRangeState(dateRange: ISODateRange): DateRangeState {
  const now = today();
  if (now < dateRange.from) return 'pending';
  if (now > dateRange.to) return 'expired';
  return 'active';
}

export function getEffectiveDateRange(
  dateRange: ISODateRange,
  state: DateRangeState
): [string, string] {
  if (state === 'active') {
    return [dateRange.from, subtractDays(today(), 1)];
  }
  return [dateRange.from, dateRange.to];
}
